module.exports = __webpack_public_path__ + "img/kite-surfing.4a92443d.jpeg";